import { KeyboardEvent } from 'react';
import { askedIndex, previewCaption } from '../OcclusionEditor/occlusionStudy';
import ReviewCard from '../ReviewCard/ReviewCard';
import {
  cartaoDaPrevia,
  type CompositorPreviewProps,
  type FacePrevia,
} from './cartaoDaPrevia';

const FACES: readonly { value: FacePrevia; label: string }[] = [
  { value: 'frente', label: 'Frente' },
  { value: 'verso', label: 'Verso' },
];

/** Pré-visualização ao vivo: o mesmo `ReviewCard` da sessão de estudo. */
export default function CompositorPreview(props: CompositorPreviewProps) {
  const { face, onFaceChange, subjectName, resolveImageUrl, forma, masks } = props;
  const card = cartaoDaPrevia(props);
  const otherFace: FacePrevia = face === 'frente' ? 'verso' : 'frente';
  const showCaption = forma === 'oclusao' && masks.length > 0;

  const handleFaceKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'ArrowUp':
      case 'ArrowDown':
        break;
      default:
        return;
    }
    event.preventDefault();
    onFaceChange(otherFace);
    const buttons = event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="radio"]');
    buttons[otherFace === 'frente' ? 0 : 1]?.focus();
  };

  return (
    <aside
      data-compositor-preview
      data-preview-face={face}
      className="flex w-full min-w-0 flex-col gap-3"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-[11px] font-semibold uppercase tracking-wider text-ink-muted">
          Pré-visualização
        </h2>
        <div
          role="radiogroup"
          aria-label="Face da pré-visualização"
          onKeyDown={handleFaceKeyDown}
          className="inline-flex rounded-full border border-edge bg-surface-muted p-0.5"
        >
          {FACES.map((option) => {
            const chosen = face === option.value;
            return (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={chosen}
                tabIndex={chosen ? 0 : -1}
                onClick={() => onFaceChange(option.value)}
                className={`rounded-full border px-3 py-1 text-xs font-semibold ${
                  chosen
                    ? 'border-select/[0.42] bg-select/[0.14] text-select-ink'
                    : 'border-transparent text-ink-muted hover:text-ink'
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
      <ReviewCard
        card={card}
        flipped={face === 'verso'}
        onToggleFlip={() => onFaceChange(otherFace)}
        subjectName={subjectName}
        resolveImageUrl={resolveImageUrl}
      />
      {showCaption ? (
        <p className="text-sm text-ink-secondary">
          {previewCaption(
            face === 'frente' ? 'front' : 'back',
            askedIndex(null, masks.length),
            masks.length,
          )}
        </p>
      ) : null}
    </aside>
  );
}
